import { ResourceOptions } from 'react-admin';
import { FaUsers } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingUsers;
export const icon = FaUsers;
export const options: ResourceOptions = {
  label: 'module.socialTrading.users',
};
